import { useWorkerStore } from '../worker/useWorkerStore';
import { User } from '../generated/gql-types';
import { upsertMany } from '../util/zustand.util';

export const storeAvailableWorkersInWorkerStore = (
  availableWorkers: User[],
): void => {
  try {
    useWorkerStore.setState((state) => ({
      workers: upsertMany(state.workers, availableWorkers),
    }));
  } catch (error) {
    console.error('Error storing available workers in worker store: ', error);
  }
};
